/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_Reward_CardsInputs */



/**
* | output |
* | --- |
* | "A level-up card for every perk" |
*
* @param {Pricing_Compare_Leveling_Reward_CardsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_reward_cards = /** @type {((inputs?: Pricing_Compare_Leveling_Reward_CardsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_Reward_CardsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Своя карточка повышения уровня для каждой привилегии")
	return /** @type {LocalizedString} */ ("A level-up card for every perk")
});